// React Basic and Bootstrap
import React, { Component } from "react"
import { Container } from "reactstrap"

// Import components
import ShaftPriceEstimator from "./ShaftPriceEstimator"

class Description extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="section">
          <Container>
            {/* Propeller Shaft Price Estimator */}
            <ShaftPriceEstimator />
          </Container>
        </section>
      </React.Fragment>
    )
  }
}

export default Description
